import { Component, Inject, Input, Optional } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { APP_NAME } from "../../../app.module";
@Component({
  selector: "app-modal-header-common",
  templateUrl: "./modal-header-common.component.html",
  styleUrls: ["./modal-header-common.component.scss"],
})
export class ModalHeaderCommonComponent {
  @Input() title: any;
  @Input() dialogRef!: MatDialogRef<any>;

  constructor(
    @Optional() @Inject(APP_NAME) public appName: string = "kepler"
  ) {}

  onCloseClick() {
    console.log(this.dialogRef);
    this.dialogRef.close();
  }

  get isRubin(): boolean {
    return this.appName === "rubin";
  }
}
